var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs--head"},_vm._l((_vm.onlyTabs),function(tab,index){return _c('li',{key:tab.title,staticClass:"tab",class:{
        tab__active: _vm.selectedIndex === index
      },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._t(`tab-title-${index}`,function(){return [_vm._v(" "+_vm._s(tab.title)+" ")]},{"title":tab.title,"tabObj":tab})],2)}),0),_c('div',{staticClass:"tabs--content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }